import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Banner from "../../components/IELTS_Academic/Banner"
import Menu from "../../components/IELTS_Academic/Menu"
import RecomendedCourses from "../../components/IELTS_Academic/RecomendedCourses"
import ReadingModule from "../../components/IELTS_Academic/ReadingModule"

const Reading = () => (
  <Layout>
    <SEO title="IELTS Academic - Reading" />
    <main>
        <Banner />
        <Menu />
        <ReadingModule />
        <RecomendedCourses />
    </main>
  </Layout>
)

export default Reading
